/**
 * Shared string/date utility functions used across the frontend.
 */

/** Convert a slug or underscore/hyphen-separated string to Title Case. */
export function titleCaseWords(value: string | null | undefined): string {
  if (typeof value !== "string" || value.length === 0) return "";
  return value
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Title-case a dotted/underscored/hyphenated key without touching the casing of
 * the rest of each segment: `pull_request.created` → `Pull Request Created`,
 * `riskDetected` → `RiskDetected`. Unlike `titleCaseWords` this splits on `.`
 * too, which is how connector keys and event semantic types are written.
 */
export function titleCaseSlug(value: string | null | undefined): string {
  if (typeof value !== "string" || value.length === 0) return "";
  return value
    .split(/[._-]/)
    .filter(Boolean)
    .map((part) => `${part[0]?.toUpperCase() ?? ""}${part.slice(1)}`)
    .join(" ");
}
